export enum DigitalCardReviewStatus {
    pendingReview = 'pending-review',
    approved = 'approved',
    changesRequested = 'changes-requested',
}
